module.exports = __webpack_public_path__ + "static/media/logos_squares_Diamond_Yordland.0dec3f11.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/partners_logos/logos_squares_Diamond_Yordland.png
// module id = 79
// module chunks = 0